import React from 'react';

const Gallery = () => {
  const images = [
    {
      src: 'https://images.unsplash.com/photo-1519741497674-611481863552?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
      alt: 'Wedding ceremony',
      span: 'col-span-2 row-span-2',
    },
    {
      src: 'https://images.unsplash.com/photo-1511285560929-80b456fea0bc?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
      alt: 'Couple exchange vows',
      span: 'col-span-1 row-span-1',
    },
    {
      src: 'https://images.unsplash.com/photo-1465495976277-4387d4b0b4c6?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
      alt: 'Wedding reception',
      span: 'col-span-1 row-span-1',
    },
    {
      src: 'https://images.unsplash.com/photo-1522673607200-164d1b6ce486?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
      alt: 'Outdoor ceremony',
      span: 'col-span-1 row-span-2',
    },
    {
      src: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
      alt: 'Wedding rings',
      span: 'col-span-1 row-span-1',
    },
    {
      src: 'https://images.unsplash.com/photo-1460978812857-470ed1c77af0?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
      alt: 'Couple walking',
      span: 'col-span-1 row-span-1',
    },
  ];

  return (
    <div className="pt-20" data-testid="gallery-page">
      {/* Hero */}
      <section className="relative py-24 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-b from-brand-moody/30 to-brand-charcoal" />
        
        <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <p className="text-gold-500 tracking-[0.3em] uppercase text-sm mb-4">
            Captured Moments
          </p>
          <h1 className="text-4xl md:text-5xl font-serif text-warm-100 mb-6">
            Gallery
          </h1>
          <div className="divider-gold max-w-xs mx-auto" />
          <p className="text-warm-100/70 text-lg max-w-2xl mx-auto mt-6">
            Glimpses of love celebrated. Each image represents a unique story, 
            a sacred moment, and a forever beginning.
          </p>
        </div>
      </section>

      {/* Gallery Grid */}
      <section className="section-container">
        <div className="grid grid-cols-2 md:grid-cols-3 gap-4 auto-rows-[200px] md:auto-rows-[250px]">
          {images.map((image, index) => (
            <div
              key={index}
              className={`relative overflow-hidden rounded-sm group ${image.span}`}
            >
              <img
                src={image.src}
                alt={image.alt}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-brand-charcoal/0 group-hover:bg-brand-charcoal/40 transition-colors duration-300" />
            </div>
          ))}
        </div>

        <p className="text-center text-warm-100/50 text-sm mt-12">
          More photos coming soon. Want to share your ceremony photos? Contact us!
        </p>
      </section>
    </div>
  );
};

export default Gallery;
